import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header'; // Import shared header
import '../css/Login.css'; // Ensure this file is scoped to the login page

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(
        `${API_BASE_URL}/login`,
        { email, password },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const { access_token, role } = response.data;
      localStorage.setItem('token', access_token);
      if (role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/user');
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || 'Login failed');
      } else {
        setError('An unexpected error occurred');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Header /> {/* Use shared header */}
      
      <div className="align">
        <div className="grid align__item">
          <div className="register">
            <svg xmlns="http://www.w3.org/2000/svg" className="site__logo" width="56" height="84" viewBox="77.7 214.9 274.7 412">
              <defs>
                <linearGradient id="a" x1="0%" y1="0%" y2="0%">
                  <stop offset="0%" stopColor="#8ceabb" />
                  <stop offset="100%" stopColor="#378f7b" />
                </linearGradient>
              </defs>
              <path fill="url(#a)" d="M215 214.9c-83.6 123.5-137.3 200.8-137.3 275.9 0 75.2 61.4 136.1 137.3 136.1s137.3-60.9 137.3-136.1c0-75.1-53.7-152.4-137.3-275.9z" />
            </svg>

            <h2>Sign In</h2>

            <form className="form" autoComplete="off" onSubmit={handleSubmit}>
              {error && <div className="error-message">{error}</div>}

              <div className="form__field">
                <input
                  type="email"
                  placeholder="info@mailaddress.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form__field">
                <input
                  type="password"
                  placeholder="••••••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form__field">
                <input
                  type="submit"
                  value={loading ? 'Loading...' : 'Sign In'}
                  disabled={loading}
                />
              </div>
            </form>

            <p className="signup-text">Don't have an account? <Link to="/register">Sign Up</Link></p>
          </div>
        </div>
        
      </div>
      <footer className="login-footer">
        <p>© 2024 SaaS Business. All rights reserved.</p>
        <div className="social-icons">
          <a href="#">LinkedIn</a> | <a href="#">Twitter</a>
        </div>
      </footer>
      

    </div>
  );
};

export default Login;
